/**
 * Anzeigename eines Nutzers. Inaktive (ausgeschiedene) Nutzer behalten ihren Namen — sie stehen
 * weiter als PL/Manager/MTB/QM an Projekten — bekommen aber den Zusatz „(inaktiv)", damit niemand
 * eine Zuständigkeit bei jemandem vermutet, der nicht mehr da ist (#116).
 *
 * `active` ist optional: fehlt es (ältere Antworten, Teil-Objekte), gilt der Nutzer als aktiv.
 */
import type { TFunction } from 'i18next';

export function anzeigeName(
  u: { name: string; active?: boolean | undefined },
  t: TFunction,
): string {
  if (u.active === false) return `${u.name} ${t('common.inaktiv_suffix', '(inaktiv)')}`;
  return u.name;
}
